<div class="main-container">
    <img src="assets/GlobeIQ_Icon.svg">
    <div class="message">Page not found</div>
    <div class="styled-button" [routerLink]="[home]">Go Home</div>
</div>